import React from 'react';
import ScheduleMap from './components/scheduleMap/scheduleMap';
import Svgs from './components/svg/svg';

const App = () => {
	const scheduleMap = document.getElementById('schedule-map');
  return (
    <>
      <Svgs></Svgs>
		  {scheduleMap && <ScheduleMap></ScheduleMap>}
    </>
  );
};

export default App;
